import { render, staticRenderFns } from "./aboutDeed.vue?vue&type=template&id=f2a3f050&"
import script from "./aboutDeed.vue?vue&type=script&lang=js&"
export * from "./aboutDeed.vue?vue&type=script&lang=js&"
import style0 from "./aboutDeed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports